import DgHamburgerButton from "./HamburgerButton.vue";

DgHamburgerButton.install = Vue => {
  Vue.component(DgHamburgerButton.name, DgHamburgerButton);
};

export default DgHamburgerButton;
